// GroupFilterDropdown.js
import React from "react";
import FilterDropdown from "./FilterDropdown";

const GroupFilterDropdown = ({
  distinctGroups,
  selectedGroupFilters,
  onToggleGroupFilter,
  onClearGroupFilters,
  label = "Filter by group:",
}) => {
  return (
    <FilterDropdown
      buttonId="groupFilterButton"
      label={label}
      title="Filter by group"
      dropdownTitle="Filter Groups"
      searchPlaceholder="Search groups..."
      emptyText="No groups found"
      options={distinctGroups}
      selectedValues={selectedGroupFilters}
      onToggle={onToggleGroupFilter}
      onClear={onClearGroupFilters}
      buttonText="Filter"
      activeBackgroundColor="#1976d2"
      inactiveTextColor="#333"
    />
  );
};

export default GroupFilterDropdown;
